import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "./ui/dialog";
import { Reveal, SectionHeading } from "./Reveal";

const TRAINERS = [
    {
        id: "ania",
        name: "Anna Popławska",
        role: "Lektorka · trenerka · technologie",
        photo: "/images/new2.webp",
        alt: "Anna Popławska - współtwórczyni EduNation",
        bio: "Lektorka języka angielskiego i trenerka nauczycieli języków obcych. Pasjonatka nowoczesnych technologii - uczy nauczycieli, jak korzystać z innowacyjnych narzędzi i aplikacji. Wcześniej dyrektorka metodyczna w dużych szkołach językowych. Prowadziła konferencje edukacyjne, autorskie szkolenia i warsztaty.",
        bioImage: "/images/ania-bio.webp",
        tags: ["Lektor angielskiego", "Dyrektor metodyczny", "Technologie w nauczaniu"],
    },
    {
        id: "luiza",
        name: "Luiza Wójtowicz-Waga",
        role: "Trenerka · coach · uczenie dorosłych",
        photo: "/images/new3.webp",
        alt: "Luiza Wójtowicz-Waga - współtwórczyni EduNation",
        bio: "Specjalistka od uczenia dorosłych - od 18 lat prowadzi zajęcia z języka angielskiego dla dorosłych w biznesie, od 10 lat jest trenerką i coachem nauczycieli (absolwentka szkoły trenerów TROP). Moderatorka metody Design Thinking. Pracuje z nauczycielami nad pewnością siebie, kreatywnością i komunikacją.",
        bioImage: "/images/luiza-bio.webp",
        tags: ["Uczenie dorosłych", "Trener i coach nauczycieli", "Design Thinking"],
    },
];

export const Trainers = () => {
    const [active, setActive] = useState(null);

    return (
        <section
            id="prowadzace"
            data-testid="trainers-section"
            className="py-20 sm:py-28 bg-cream-deep overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    kicker="Prowadzące"
                    title="Dwie trenerki. Setki przeprowadzonych szkoleń. Prawdziwe sytuacje z lekcji."
                    lead="Kurs przygotowały Ania i Luiza - twórczynie EduNation, największego centrum szkoleniowego dla nauczycieli języków obcych w Polsce."
                />
                <div className="mt-14 grid md:grid-cols-2 gap-8 lg:gap-12">
                    {TRAINERS.map((t, i) => (
                        <Reveal key={t.id} delay={i * 0.12}>
                            <article
                                data-testid={`trainer-card-${t.id}`}
                                className="group h-full rounded-[2rem] border border-border bg-white overflow-hidden shadow-soft transition-all duration-300 hover:shadow-card hover:-translate-y-1"
                            >
                                <div className="relative overflow-hidden bg-cream-deep">
                                    <img
                                        src={t.photo}
                                        alt={t.alt}
                                        loading="lazy"
                                        className="w-full h-80 sm:h-96 object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                                    />
                                    <span className="absolute top-4 left-4 rounded-full bg-tang px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-ink">
                                        {t.role}
                                    </span>
                                </div>
                                <div className="p-7 sm:p-8">
                                    <h3 className="font-display uppercase text-2xl font-bold text-ink">
                                        {t.name}
                                    </h3>
                                    <p className="mt-3 text-sm text-ink/75 leading-relaxed">
                                        {t.bio}
                                    </p>
                                    <div className="mt-5 flex flex-wrap gap-2">
                                        {t.tags.map((tag) => (
                                            <span
                                                key={tag}
                                                className="rounded-full bg-cream-deep px-3 py-1 text-xs font-semibold text-ink-soft"
                                            >
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                    <button
                                        data-testid={`trainer-more-${t.id}`}
                                        onClick={() => setActive(t)}
                                        className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold uppercase tracking-wide text-ink border-b-2 border-ink/20 hover:border-ink transition-colors pb-0.5 min-h-[44px]"
                                    >
                                        Poznaj mnie bliżej
                                        <ArrowUpRight className="w-4 h-4" />
                                    </button>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>

            <Dialog open={!!active} onOpenChange={() => setActive(null)}>
                <DialogContent
                    className="max-w-lg p-2 bg-white rounded-3xl"
                    data-testid="trainer-bio-dialog"
                >
                    <DialogHeader className="sr-only">
                        <DialogTitle>{active?.name}</DialogTitle>
                        <DialogDescription>Rozbudowana biografia prowadzącej</DialogDescription>
                    </DialogHeader>
                    {active && (
                        <img
                            src={active.bioImage}
                            alt={`Biografia - ${active.name}`}
                            className="w-full h-auto rounded-2xl"
                        />
                    )}
                </DialogContent>
            </Dialog>
        </section>
    );
};
